import { NEXT_PUBLIC_PHARMACY_BASE_URL } from "@/libs/constants/auth";

export const NEXT_PUBLIC_MAGENTO_BASE_URL = process.env.NEXT_PUBLIC_MAGENTO_BASE_URL;
export const NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN = process.env.NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN;

export const filterKeyForApi = {
  MaternityCare: "filter_contents-474606",
  MotherhoodStage: "filter_contents-474605",
};

export const getRedirectUrl = (product, isPharma = false) => {
  const { is_prescription_required, url_key } = product;

  return Number(is_prescription_required)
    ? `${NEXT_PUBLIC_PHARMACY_BASE_URL}/medicine/${url_key}${isPharma ? "" : "?utm_medium=momverse"}`
    : `${NEXT_PUBLIC_PHARMACY_BASE_URL}/otc/${url_key}${isPharma ? "" : "?utm_medium=momverse"} `;
};
